import React from 'react'
import styled, { keyframes } from 'styled-components'
import media from '../styles/media'
import Colors from '../styles/Colors'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import { ReactComponent as HomeSVG } from '../assets/svg/headHome.svg'
import { ReactComponent as AboutSVG } from '../assets/svg/headAbout.svg'
import { ReactComponent as ProductsSVG } from '../assets/svg/headProducts.svg'
import { ReactComponent as ResourcesSVG } from '../assets/svg/headResources.svg'
import { ReactComponent as CareersSVG } from '../assets/svg/headCareers.svg'
import { ReactComponent as ContactSVG } from '../assets/svg/headContact.svg'

type Props = {
  imageState: number
}

const ImagePanel: React.FC<Props> = ({ imageState }) => {
  const data = useStaticQuery(graphql`
    query {
      panelImage1: file(relativePath: { eq: "homeMenuBG.jpg" }) {
        ...fluidImage
      }
      panelImage2: file(relativePath: { eq: "aboutMenuBG.jpg" }) {
        ...fluidImage
      }
      panelImage3: file(relativePath: { eq: "productMenuBG.jpg" }) {
        ...fluidImage
      }
      panelImage4: file(relativePath: { eq: "resourcesMenuBG.jpg" }) {
        ...fluidImage
      }
      panelImage5: file(relativePath: { eq: "careersMenuBG.jpg" }) {
        ...fluidImage
      }
      panelImage6: file(relativePath: { eq: "contactMenuBG.jpg" }) {
        ...fluidImage
      }
    }
  `)

  return (
    <Wrapper active={imageState !== 0}>
      <Frame>
        <ImageWrapper>
          <BackgroundImg
            imgStyle={{ objectFit: 'cover', objectPosition: 'center' }}
            fluid={data.panelImage1.childImageSharp.fluid}
            active={imageState === 1}
          />
          <SVGWrapper active={imageState === 1}>
            <Home />
          </SVGWrapper>
        </ImageWrapper>
        <ImageWrapper>
          <ImageWrapper>
            <BackgroundImg
              imgStyle={{ objectFit: 'cover', objectPosition: 'center' }}
              fluid={data.panelImage2.childImageSharp.fluid}
              active={imageState === 2}
            />
            <SVGWrapper active={imageState === 2}>
              <About />
            </SVGWrapper>
          </ImageWrapper>

          <BackgroundImg
            imgStyle={{ objectFit: 'cover', objectPosition: 'center' }}
            fluid={data.panelImage3.childImageSharp.fluid}
            active={imageState === 3}
          />
          <SVGWrapper active={imageState === 3}>
            <Products />
          </SVGWrapper>
        </ImageWrapper>
        <ImageWrapper>
          <BackgroundImg
            imgStyle={{ objectFit: 'cover', objectPosition: 'center' }}
            fluid={data.panelImage4.childImageSharp.fluid}
            active={imageState === 4}
          />
          <SVGWrapper active={imageState === 4}>
            <Resources />
          </SVGWrapper>
        </ImageWrapper>
        <ImageWrapper>
          <BackgroundImg
            imgStyle={{ objectFit: 'cover', objectPosition: 'center' }}
            fluid={data.panelImage5.childImageSharp.fluid}
            active={imageState === 5}
          />
          <SVGWrapper active={imageState === 5}>
            <Careers />
          </SVGWrapper>
        </ImageWrapper>
        <ImageWrapper>
          <BackgroundImg
            imgStyle={{ objectFit: 'cover', objectPosition: 'center' }}
            fluid={data.panelImage6.childImageSharp.fluid}
            active={imageState === 6}
          />
          <SVGWrapper active={imageState === 6}>
            <Contact />
          </SVGWrapper>
        </ImageWrapper>
      </Frame>
    </Wrapper>
  )
}

const Wrapper = styled.div<{ active: boolean }>`
  position: fixed;
  width: 0;
  height: calc(100vh - 96px);
  opacity: ${(props) => (props.active ? 1 : 0)};
  transition: 800ms cubic-bezier(0.72, 0, 0.12, 1);
  width: calc(100vw - 839px);
  z-index: ${(props) => (props.active ? 80 : -1)};
  background: ${Colors.whiteSmoke};
  left: 0;
  top: 96px;
  overflow: hidden;
  line-height: 0;
  padding: 6px;
  ${media.tabletLandscape} {
    display: none;
  }
`

const Frame = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 10;
  ${media.tablet} {
  }
`
const ImageWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
`
const BackgroundImg = styled(Img)<{ active: boolean; fluid: any }>`
  width: 100%;
  height: 100%;
  opacity: ${(props) => (props.active ? 1 : 0)};
  transform: ${(props) => (props.active ? 'scale(1)' : 'scale(1.05)')};
  transition: 800ms cubic-bezier(0.72, 0, 0.12, 1);
`

const Home = styled(HomeSVG)`
  width: 5.5vw;
  max-width: 93px;

  ${media.fullWidth} {
    max-width: 5.5vw;
  }
`
const About = styled(AboutSVG)`
  width: 5.5vw;
  max-width: 93px;

  ${media.fullWidth} {
    max-width: 5.5vw;
  }
`
const Products = styled(ProductsSVG)`
  width: 5.5vw;
  max-width: 93px;

  ${media.fullWidth} {
    max-width: 5.5vw;
  }
`
const Resources = styled(ResourcesSVG)`
  width: 5.5vw;
  max-width: 93px;

  ${media.fullWidth} {
    max-width: 5.5vw;
  }
`
const Careers = styled(CareersSVG)`
  width: 5.5vw;
  max-width: 93px;

  ${media.fullWidth} {
    max-width: 5.5vw;
  }
`
const Contact = styled(ContactSVG)`
  width: 5.5vw;
  max-width: 93px;

  ${media.fullWidth} {
    max-width: 5.5vw;
  }
`

const SVGWrapper = styled.div<{ active: boolean }>`
  position: absolute;
  left: 0;
  bottom: 24px;
  transition: 800ms cubic-bezier(0.72, 0, 0.12, 1);
  left: ${(props) => (props.active ? '5px' : 'calc(-100% + 5px)')};
`

export default ImagePanel
